import { useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import returnsServices from '@/returns/services/services'

import { transformRequestModifyAmounts } from './transformers'

const useModifyAmounts = ({ returnId, fetchData, fetchTimeline, setToastInfo }) => {
  const [showEditTransactionResultDrawer, setShowEditTransactionResultDrawer] = useState(false)
  const { fetchData: modifyAmounts, loading: modifying } = useFetch(returnsServices.modifyAmounts, {
    doInitialRequest: false,
    transformRequest: transformRequestModifyAmounts,
  })

  const openEditTransactionResultDrawer = () => {
    setShowEditTransactionResultDrawer(true)
  }

  const closeEditTransactionResultDrawer = () => {
    setShowEditTransactionResultDrawer(false)
  }

  const handleSaveModifyAmounts = async ({ transactionConcepts, refundMethodSelected, note }) => {
    try {
      await modifyAmounts({ returnId, concepts: transactionConcepts, refundMethod: refundMethodSelected, note })
      closeEditTransactionResultDrawer()
      fetchData()
      fetchTimeline()
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  return {
    showEditTransactionResultDrawer,
    openEditTransactionResultDrawer,
    closeEditTransactionResultDrawer,
    handleSaveModifyAmounts,
    modifying,
  }
}

export default useModifyAmounts
